var _defs, _rect, _use, _use2, _use3, _use4, _use5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnchinaflag111955(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z",
    fill: "#ffde00"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#de2910"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(5,5) scale(3)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(10,2) rotate(23.036243)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(12,4) rotate(45.869898)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(12,7) rotate(69.945396)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(10,9) rotate(20.659808)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnchinaflag111955);
export default __webpack_public_path__ + "static/media/cnchinaflag_111955.fc16898dcaf75a8cfc57ab5491ac8d91.svg";
export { ForwardRef as ReactComponent };